import { render, staticRenderFns } from "./PhoneVerificationStatus.vue?vue&type=template&id=1b58670c&"
import script from "./PhoneVerificationStatus.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports